module.exports = __webpack_public_path__ + "img/galeria_salas_de_aula (5).1a304e56.jpeg";